import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ModalDirective } from 'ng2-bootstrap';
import { combineLatest, Observable, timer } from 'rxjs';

import { SecurityService } from '../../services/settings/security.service';
import { ServiceLocator } from '../../services/base/service-locator';
import { Activity } from '../../models/activity';

import { WebMethodResult } from '../../models/web-method-result';
import { Event, EventId } from '../../models/base/event';
import { KeyCodes } from '../../models/base/key-codes';

import { DocumentItem } from 'app/models/document/document-item';
import { AppModulePath } from 'app/models/app-module-path';
import { camelCase, isNil, merge, startsWith } from 'lodash';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';


declare var $: any;

@Component({
  selector: 'bms-base',
  template: '',
  providers: []
})
export class BaseComponent implements OnInit {

  private enterAsTabEnabled: boolean;
  protected errorObj: WebMethodResult;
  protected successString: string;

  integerPattern = '^[0-9]+$';
  integerPatterngGeaterThanZero = '^[1-9][0-9]*$';
  realPattern = '^((\\+|-)?([0-9]+)(\\.[0-9]+)?)|((\\+|-)?\\.?[0-9]+)$';
  realPatternTwoDecimal = '[-+]?[0-9]*[.]?([0-9][0-9]?)?';
  realPatternThreeDecimal = '[-+]?[0-9]*[.]?([0-9]{1,3})?';
  zipCodePattern = '[0-9]{5}';
  tinPattern = '[0-9]{9}';
  indCodePattern = '[0-9]{5}';
  idNumberPattern = '[0-9]{8}';
  colorPattern = '[0-9A-Fa-f]+';

  protected stornoPermission = false;
  protected razresenjePermission = false;

  @Output()
  protected events: EventEmitter<Event> = new EventEmitter();

  @Input()
  @ViewChild('thisDialog', { static: false })
  protected thisDialog: ModalDirective;

  @ViewChild('focusControl', { static: false })
  protected focusControl: ElementRef;

  protected securityService: SecurityService;
  protected router: Router;
  protected translateSvc: TranslateService;

  protected readGranted = false;
  protected writeGranted = false;
  protected deleteGranted = false;
  public activities;

  translateParams: object = {};

  private errorDialogTitle: string;
  private errorDialogButton: string;
  private successDialogTitle: string;
  private successDialogButton: string;

  protected noAccessToPageMsg: string;
  protected yesButton: string;
  protected noButton: string;
  protected areYouSureMsg: string;

  protected deleteDlgYes: string;
  protected deleteDlgTitle: string;

  get contextPath(): string {
    return document.getElementsByTagName('base')[0].getAttribute('href') || '/';
  }

  constructor() {
    this.enterAsTabEnabled = false;
    this.securityService = ServiceLocator.injector.get(SecurityService);
    this.router = ServiceLocator.injector.get(Router);
    this.translateSvc = ServiceLocator.injector.get(TranslateService);

    this.events.subscribe($.proxy(this.onEvent, this));

    this.transl(['dialogs.error.title', 'dialogs.error.okButton', 'dialogs.success.title', 'dialogs.success.okButton',
      'baseComponent.messages.noAccessToPage', 'dialogs.delete.yesButton', 'dialogs.delete.title', 'buttons.yes', 'buttons.no',
      'dialogs.messages.areYouSure']).subscribe(t => {
        this.errorDialogTitle = t.dialogsErrorTitle;
        this.errorDialogButton = t.dialogsErrorOkButton;
        this.successDialogTitle = t.dialogsSuccessTitle;
        this.successDialogButton = t.dialogsSuccessOkButton;
        this.noAccessToPageMsg = t.baseComponentMessagesNoAccessToPage;
        this.deleteDlgYes = t.dialogsDeleteYesButton;
        this.deleteDlgTitle = t.dialogsDeleteTitle;
        this.yesButton = t.buttonsYes;
        this.noButton = t.buttonsNo;
        this.areYouSureMsg = t.dialogsMessagesAreYouSure;
      });
  }

  public transl(keys: string[]): Observable<{ [key: string]: any }> {
    const obsTrans: Observable<any>[] = keys.map(key => this.translateSvc.get(key));
    return combineLatest(obsTrans).pipe(
      map(translations => {
        const res: { [key: string]: any } = {};
        keys.forEach((key: string, idx: number) => {
          merge(res, { [camelCase(key)]: translations[idx] });
        });
        return res;
      }));
  }

  enableEnterAsTab(enabled: boolean) {
    this.enterAsTabEnabled = enabled;
  }

  protected initTranslationParams() {
  }

  ngOnInit() {
    if (!isNil(this.thisDialog)) {
      this.thisDialog.onShown.subscribe($.proxy(this.onShown, this));
    }
    this.initTranslationParams();
    this.activities = this.securityService.getGrantedActivities();
  }

  public showFilter() {
    $('div.filter').css('display', 'block');
  }

  public importer() {
    const inputs = document.querySelectorAll('#importer');
    Array.prototype.forEach.call(inputs, function (input) {
      const label = input.nextElementSibling,
        labelVal = label.innerHTML;

      input.addEventListener('change', function (e) {
        let fileName = '';
        if (this.files && this.files.length > 1) {
          fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        } else {
          fileName = e.target.value.split('\\').pop();
        }

        if (fileName) {
          label.querySelector('span').innerHTML = fileName;
        } else {
          label.innerHTML = labelVal;
        }
      });
    });
  }

  public importer2() {
    const inputs = document.querySelectorAll('#importer');
    Array.prototype.forEach.call(inputs, function (input) {
      const label = input.nextElementSibling,
        labelVal = label.innerHTML;

      input.addEventListener('change', function (e) {
        let fileName = '';
        if (this.files && this.files.length > 1) {
          fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        } else {
          fileName = e.target.value.split('\\').pop();
        }
      });
    });
  }

  protected onShown() {
    if (!isNil(this.thisDialog) && !isNil(this.focusControl) && !isNil(this.focusControl.nativeElement)) {
      this.focusControl.nativeElement.focus();
    }
  }

  protected fireEvent(event: Event) {
    this.events.next(event);
  }

  // Kada pređemo na određeno INPUT polje, selektuje se ceo tekst automatski
  public onFocusSelectAll() {

  }

  public isDate(obj): boolean {
    return obj instanceof Date && !isNaN(obj.valueOf());
  }

  public iif<T>(someObject: T, defaultValue: T = {} as T): T {
    if (typeof someObject === 'undefined' || someObject === null) {
      return defaultValue;
    } else {
      return someObject;
    }
  }

  public displayErrorPage(error: any) {
    let wmr = null;
    if (typeof error === 'string') {
      // wmr = WebMethodResult.create(-1, error);
      this.showError(error);
    } else if (error instanceof WebMethodResult) {
      wmr = error;
    } else if (error instanceof Error) {
      // wmr = WebMethodResult.create(-1, error.message);
      this.showError(error.message);
    }
  }

  public showDeleteConfirm(title: string = '', text: string = ''): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: !isNil(title) && title.length > 0 ? title : this.deleteDlgTitle,
      text: !isNil(text) && text.length > 0 ? text : this.areYouSureMsg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.deleteDlgYes,
      cancelButtonText: this.noButton
    });
  }

  public showError(error: any) {
    Swal.fire({
      title: this.errorDialogTitle,
      text: error instanceof WebMethodResult ? error.description : error,
      icon: 'error',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d9534f',
      confirmButtonText: this.errorDialogButton
    }).then(() => {
    });
  }

  protected setError(error: WebMethodResult) {
    this.errorObj = error;
    timer(5000).subscribe(() => {
      this.errorObj = null;
    });
  }

  public showSuccess(successStr: string) {
    Swal.fire({
      title: this.successDialogTitle,
      text: successStr,
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d9534f',
      confirmButtonText: this.successDialogButton
    }).then(() => {
    });
  }

  protected setSuccess(success: string) {
    this.successString = success;
    timer(5000).subscribe(() => {
      this.successString = null;
    });

    // this.showSuccess(success);
  }

  protected onEvent(event: Event) {

  }

  @HostListener('window:keyup', ['$event'])
  protected keyUpHandler(event: KeyboardEvent) {
    if (event.keyCode === KeyCodes.KEY_ADD) {
      const focused = document.activeElement;
      if (focused) {
        const insertFunc = $(focused).data('insert-func');
        if (!isNil(insertFunc) && insertFunc !== '') {
          const parts: string[] = insertFunc.split('.');
          if (parts[0] === this.constructor.name) {
            const func: string[] = Object.getOwnPropertyNames(Object.getPrototypeOf(this))
              .filter((prop) => prop === parts[1]);
            if (func.length > 0) {
              this[func[0]]();
            }
          }
        } else {
          this.fireEvent(new Event(EventId.PLUS_KEY_PRESSED, this));
        }
      }
    }
  }

  @HostListener('window:keypress', ['$event'])
  private returnKeyHandler(event: KeyboardEvent) {
    if (!isNil(event.srcElement)) {
      const srcElem = $(event.srcElement);
      if (event.which === KeyCodes.KEY_RETURN) {
        if (this.enterAsTabEnabled && (srcElem[0].nodeName === 'INPUT' || srcElem[0].nodeName === 'SELECT' ||
          srcElem[0].nodeName === 'TEXTAREA' || srcElem[0].nodeName === 'LABEL') || srcElem[0].nodeName === 'CHECKBOX') {
          if (event.shiftKey) {
            event.preventDefault();
            let previous = $('[tabIndex=' + (+srcElem.attr('tabIndex') - 1) + ']');
            if (previous.length === 0) {
              previous = $('[tabIndex=1]');
            }
            previous.focus();
          } else {
            event.preventDefault();
            let next = $('[tabIndex=' + (+srcElem.attr('tabIndex') + 1) + ']');
            if (next.length === 0) {
              next = $('[tabIndex=1]');
            }
            next.focus();
          }
        }
      }
    }
  }

  // Pristiskom na PLUS na tastaturi otvara dijalog
  public initPlusKey() {
  }

  // U dijalogu, kada smo na određenom polju, na ENTER idemo na sledeće polje
  public initEnterAsTab() {
  }

  public checkActivity(path: string) {
    const res = this.securityService.getGrantedActivities();

    if (!isNil(res) && !isNil(res[path])) {
      // tslint:disable-next-line:no-bitwise
      if ((res[path].value & (1 << Activity.READ - 1)) > 0) {
        this.readGranted = true;
      }
      // tslint:disable-next-line:no-bitwise
      if ((res[path].value & (1 << Activity.WRITE - 1)) > 0) {
        this.writeGranted = true;
      }
      // tslint:disable-next-line:no-bitwise
      if ((res[path].value & (1 << Activity.DELETE - 1)) > 0) {
        this.deleteGranted = true;
      }
    }
  }

  public checkRouteActivity2(activities: string[]): boolean {
    if (!isNil(this.securityService.getGrantedActivities())) {
      const res = activities.map(activity => {
        let aRight = false;
        for (const gaPath in this.securityService.getGrantedActivities()) {
          aRight = aRight || startsWith(gaPath, activity);
        }
        return aRight;
      }).reduce((a, b) => a || b);
      // console.log(`Pravo na ${activities.join(',')} : ${res}`);
      return res;
    }
    return true;
  }

  public checkRouteActivity(activity) {
    const array = activity.split('/');
    const res = this.securityService.getGrantedActivities();
    for (const i in array) {
      const newInd = Number(i) + 1;
      const checkPath = array.slice(0, newInd).join('/');
      for (const obj in res) {
        if (obj === checkPath) {
          return true;
        }
      }
    }
    return false;
  }

  public checkChildrenActivity(activity) {
    const res = this.securityService.getGrantedActivities();
    for (const obj in res) {
      if (obj.includes(activity)) {
        return true;
      }
      const array = activity.split('/');
      for (const i in array) {
        const newInd = Number(i) + 1;
        const checkPath = array.slice(0, newInd).join('/');
        if (obj === checkPath) {
          return true;
        }
      }
    }
    return false;

  }

  public checkHomeActivity(activity: string) {
    const array = activity.split('/');
    const modules = ['robnoKnjigovodstvo', 'javneNabavke', 'proizvodnja', 'projekti', 'osnovnaSredstva', 'apm'];

    const res = this.securityService.getGrantedActivities();
    for (const obj in res) {
      const objArray = obj.split('/');
      if (objArray.includes(activity)) {
        return true;
      }
    }
    return false;
  }

  public tchmCheckActivity(path: string) {
    const res = this.securityService.getGrantedActivities();
    const array = path.split('/');
    //      if (!isNil(res) && res[path] !== null) {
    for (const i in array) {
      const newInd = Number(i) + 1;
      const checkPath = array.slice(0, newInd).join('/');

      for (const obj in res) {
        if (obj === checkPath) {
          if (res[checkPath].value === 1 || res[checkPath].value === 2) {
            this.readGranted = true;
          }
          if (res[checkPath].value === 2) {
            this.writeGranted = true;
          }
        }
      }
      if (this.readGranted || this.writeGranted) return true;

    }
    return false;
    //      }
  }

  public tchmCheckShowPrices(path: string): boolean {
    const res = this.securityService.getGrantedActivities();
    const module = res[path];
    if (!isNil(module)) {
      const activity = module.value;
      return !isNil(activity) && activity > 0;
    } else {
      return false;
    }
  }

  public tchmCheckStornoPermission() {
    this.stornoPermission = this.tchmCheckShowPrices(AppModulePath.STORNO_DOZVOLA);
  }

  public tchmCheckRazresenjePermission() {
    this.razresenjePermission = this.tchmCheckShowPrices(AppModulePath.RAZRESENJE_DOZVOLA);
  }

  round(n: number, digit: number) {
    if (isNil(n)) {
      return 0;
    } else {
      return Math.round(n * (10 ** digit)) / (10 ** digit);
    }
  }

  calculateTotalWithVatBase(documentItem: DocumentItem) {
    let vatIndicator = 1;
    if (documentItem.pricePerUnit === documentItem.priceWithVat) {
      if (documentItem.vatPerUnit > 0) {
        vatIndicator = 0;
      } else {
        vatIndicator = 1;
      }
    }
    if (documentItem.price && documentItem.quantity) {
      return this.round(this.iif(documentItem.variablecost, 0) - this.iif(documentItem.discount, 0) +
        (documentItem.pricePerUnit * documentItem.quantity * (1 + documentItem.vatPerUnit * vatIndicator / 100)), 2);
    }
  }


  protected baseCalculateTotalView(di: DocumentItem) {
    if (di.quantity && di.pp) {
      return +Number((di.pp * di.quantity).toFixed(2));
    }
  }

  protected baseCalculateTotalWithVatView(di: DocumentItem) {
    // let vatIndicator = 1;
    // if (di.pricePerUnit === di.priceWithVat)
    //   if (di.vatPerUnit > 0) vatIndicator = 0;
    //   else vatIndicator = 1;
    // if (di.price && di.quantity) {
    //   return +Number((this.iif(di.priceDifference,0)
    //                           + this.iif(di.variablecost,0)
    //                           - this.iif(di.discount,0)
    //                           + di.pricePerUnit*di.quantity)
    //                           * (1 + di.vatPerUnit * vatIndicator / 100)).toFixed(2);
    // }
    return +Number((di.quantity * di.price).toFixed(2));
  }

  protected calculatePurchasePriceView(di: DocumentItem) {
    if (!isNil(di.priceWithVat)) {
      return Number((+di.pricePerUnit
        + (this.iif(di.variablecost, 0) - this.iif(di.discount, 0)) / this.iif(di.quantity, 1)).toFixed(2));
    }
  }
}
